export { StepTrusteeCompanyDetails } from './TrusteeCompanyDetails';
